import { LoginError } from "./interfaces/loginRequest";



export const ModalType: { [key: number]: LoginError} = 
{
    "0":
    { Message: "",
    Type: "",
    DisplayID: 0},
    "1":
    { Message: `Internal Error`,
    Type: "Unknown",
    DisplayID: 1},
};